import {createSelector} from "reselect";

const webhooks = (state) => state.webhooks;

export const getWebhooksListData = createSelector(
  webhooks,
  (data) => data.webhooksListData || {}
);

export const getWebhooksList = createSelector(
  getWebhooksListData,
  (data) => data?.results || []
);

export const getWebhooksTotalCount = createSelector(
  getWebhooksListData,
  (data) => data?.count
);

export const getWebhooksPaginationUrls = createSelector(getWebhooksListData, (data) => ({
  prevUrl: data?.previous,
  nextUrl: data?.next,
}));

export const getWebhookDeliverLogsData = createSelector(
  webhooks,
  (data) => data.webhookDeliverLogsData || {}
);

export const getDeliveryLogs = createSelector(
  getWebhookDeliverLogsData,
  (data) => data?.results || []
);

export const getDeliveryLogsTotalCount = createSelector(
  getWebhookDeliverLogsData,
  (data) => data?.count
);

export const getDeliveryLogsPaginationUrls = createSelector(
  getWebhookDeliverLogsData,
  (data) => ({
    prevUrl: data?.previous,
    nextUrl: data?.next,
  })
);
